import { render, staticRenderFns } from "./OrganisationUnitsList.vue?vue&type=template&id=e139ac48&scoped=true&"
import script from "./OrganisationUnitsList.vue?vue&type=script&lang=js&"
export * from "./OrganisationUnitsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e139ac48",
  null
  
)

export default component.exports